import { render, staticRenderFns } from "./FmxOpeningHours.vue?vue&type=template&id=2cf61604&"
import script from "./FmxOpeningHours.vue?vue&type=script&lang=js&"
export * from "./FmxOpeningHours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports